module.exports = __webpack_public_path__ + "static/media/Restrictions_on_internal_movement_delay.4ae9cfb8.svg";